import { CardContent } from '@/queries/supreme-cards';

type Benefit = {
    cards: { name: string }[];
};

// Explicit cardOrder first; the rest (and ties) by fewest benefits.
export const sortCards = (cards: CardContent[], benefits: Benefit[] = [], hiddenCards: number[] = [], cardOrder: number[] = []) => {
    const benefitCount: Record<string, number> = {};
    benefits.forEach(benefit => {
        benefit.cards.forEach(({ name }) => {
            benefitCount[name] = (benefitCount[name] ?? 0) + 1;
        });
    });

    const position = (card: CardContent) => {
        const index = cardOrder.indexOf(card.id);
        return index === -1 ? cardOrder.length : index;
    };

    return cards
        .filter(card => !hiddenCards.includes(card.id))
        .sort((a, b) => position(a) - position(b) || (benefitCount[a.post_title] ?? 0) - (benefitCount[b.post_title] ?? 0));
};
